// extracted by mini-css-extract-plugin
module.exports = {"colorSuccess":"#4a8062","colorWarning":"#80804a","colorDanger":"#8d4040"};